import { createEventDate } from "@anggunpraya-templates/base/app/utils/create-event-date";
import { defineClientConfig } from "@anggunpraya-templates/base/config/define-client-config";
import { defineAp006TemplateConfig } from "../app/schemas/template";

const weddingDate = createEventDate({
  date: "2026-06-07",
  time: "09:00",
  timezone: "WITA",
});

const seoTheme = {
  colorScheme: "dark",
  themeColor: "#070707",
} as const;

export const clientConfig = defineClientConfig({
  eventCode: "AP-20260531-2724",

  template: defineAp006TemplateConfig({
    general: {
      // Nama lengkap pengantin pria
      groom_name: "Maha Deva Zulvicar, S.Kom",
      // Nama panggilan pengantin pria
      groom_nickname: "Deva",

      // Nama lengkap pengantin wanita
      bride_name: "Rifqah Azzah Mu'tashimah, S.Kom",
      // Nama panggilan pengantin wanita
      bride_nickname: "Rifqah",

      date: weddingDate.iso,
      time: weddingDate.time,
      subdomain: "deva-dan-rifqah",
      initials: {
        groom: "D",
        bride: "R",
      },
      parents: {
        groom: {
          father: "AKP Syafingi",
          mother: "Heriyanti",
          order: "Pertama",
        },
        bride: {
          father: "Mohamad Ismail, S.Pd.I",
          mother: "ST. Fatimah",
          order: "Pertama",
        },
      },
      instagram: {
        groom: {
          label: "Deva",
          href: "https://instagram.com/",
        },
        bride: {
          label: "Rifqah",
          href: "https://instagram.com/",
        },
      },
    },

    others: {
      seo_theme: seoTheme,
      music: {
        enabled: true,
        src: "https://template.anggunpraya.id/audio/tadashikeiji-itx27s-all-about-you-332097/tadashikeiji-itx27s-all-about-you-332097.mp3",
      },
    },

    hero: {
      key: "hero",
      enabled: true,
      quotes: {
        text: "Dan di antara tanda-tanda kebesaran-Nya ialah Dia menciptakan pasangan-pasangan untukmu dari jenismu sendiri.",
        source: "QS. Ar-Rum: 21",
      },
    },

    events: {
      key: "events",
      enabled: true,
    },

    location: {
      key: "location",
      enabled: true,
      items: [
        {
          activity: "Akad Nikah",
          venue: "Al Auliya Hall",
          address: "Jl. MT Haryono No.137 RT 43, Batu Ampar, Kec. Balikpapan Utara, Kota Balikpapan",
          maps_link: "https://maps.app.goo.gl/6km98RLKCS9fxYKg6",
          start_time: "09:00",
          end_time: "11:00",
        },
        {
          activity: "Resepsi",
          venue: "Al Auliya Hall",
          address: "Jl. MT Haryono No.137 RT 43, Batu Ampar, Kec. Balikpapan Utara, Kota Balikpapan",
          maps_link: "https://maps.app.goo.gl/6km98RLKCS9fxYKg6",
          start_time: "12:00",
          end_time: "15:00",
        },
      ],
    },

    gallery: {
      key: "gallery",
      enabled: true,
      imageCount: 9,
    },

    rsvp: {
      key: "rsvp",
      enabled: true,
    },

    dress_code: {
      enabled: false,
      key: "dress_code",
      style: "Formal",
      color: "Monochrome",
    },

    gift: {
      key: "gift",
      enabled: true,
      bank_accounts: [
        {
          bank_name: "Mandiri",
          account_name: "Maha Deva Zulvicar",
          account_number: "14*********33",
          icon: "/bank-first.svg",
        },
        {
          bank_name: "SeaBank",
          account_name: "Rifqah Azzah Mu'tashimah",
          account_number: "90********12",
          icon: "/bank-second.svg",
        },
      ],
    },

    wishes: {
      key: "wishes",
      enabled: true,
    },
  }),
});
